import React from 'react';
import { WEB3FORMS_ACCESS_KEY } from '../../config.js';

const Contact = () => {
  const [status, setStatus] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatus(null);

    try {
      const formData = new FormData(event.target);
      formData.append('access_key', WEB3FORMS_ACCESS_KEY);

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        setStatus({
          type: 'success',
          message: 'Thanks! Your message was sent successfully.',
        });
        event.target.reset();
      } else {
        setStatus({
          type: 'error',
          message: result.message || 'Something went wrong. Please try again.',
        });
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Unable to submit the form right now. Please try again later.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '820px', margin: '20px auto', padding: '20px' }}>
      <h1>Contact Us</h1>
      <p>We&apos;d love to hear from you. Use the form below and we&apos;ll get back to you soon.</p>

      {status && (
        <div className={`alert alert-${status.type === 'success' ? 'success' : 'danger'}`}>
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="mb-4">
        <div className="mb-3">
          <label htmlFor="contact-name" className="form-label">Name</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="contact-email" className="form-label">Email</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="contact-subject" className="form-label">Subject</label>
          <input
            id="contact-subject"
            name="subject"
            type="text"
            className="form-control"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="contact-message" className="form-label">Message</label>
          <textarea
            id="contact-message"
            name="message"
            rows="6"
            className="form-control"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>

      <h2>Other Notes</h2>
      <ul style={{ fontSize: '1rem' }}>
        <li><strong>Content Creators:</strong> Include links to your channel and best videos.</li>
        <li><strong>Technical Issues:</strong> Share your browser, device, and steps to reproduce.</li>
        <li><strong>General Feedback:</strong> We love ideas to improve ASMR.guru.</li>
      </ul>
    </div>
  );
};

export default Contact;
